import { Typography } from '@axafr-btc-ds/typography';
import { Selectable, SelectableGroupMulti } from '@axa-fr-axion/selectable';
import classNames from 'classnames';
import { Product as ProductItem } from '../product';
import { ProductListProps } from './ProductList.interface';
import styles from './ProductList.module.css';

const even = 2;

export const ProductList = (data: ProductListProps): JSX.Element => {
    const { className, title, description, products, value, labelledBy, onChange } = data;

    const isLast = (index: number) => {
        return index % even === 0 && index === products.length - 1;
    };

    return (
        <div className={ classNames(styles.host, className) }>
            { title && (
                <Typography variant="title3">
                    { title }
                </Typography>
            ) }

            { description && (
                <Typography
                    className={ styles.description }
                    variant="body1"
                >
                    { description }
                </Typography>
            ) }

            <SelectableGroupMulti
                className={ styles.products }
                labelledby={ labelledBy }
                value={ value }
                onChange={ onChange }
            >
                { products.map((product, index) => (
                    <Selectable
                        className={ classNames(styles.selectable, { [ styles.lastItem ]: isLast(index) }) }
                        labelledby={ product.codeProduit }
                        value={ product.codeProduit }
                        key={ product.codeProduit }
                    >
                        <ProductItem
                            code={ product.codeProduit }
                            seeMore={ product.enSavoirPlus }
                            selected={ value?.includes(product.codeProduit) }
                            title={ product.libelleProduit }
                        />
                    </Selectable>
                )) }
            </SelectableGroupMulti>
        </div>
    );
};
